import React, { Component } from 'react';

class Boundary extends Component {
  constructor(props) {
    super(props);

    this.state = {
      hasError: false,
    };
  }

  static getDerivedStateFromError() {
    return {
      hasError: true,
    };
  }

  componentDidCatch(error, info) {
    console.log(error, info);
  }

  render() {
    if (this.state.hasError) {
      if (this.props.fallbackComponent) {
        return this.props.fallbackComponent;
      }

      return (
        <div style={{ color: 'red', padding: 5 }}>{this.props.fallback}</div>
      );
    }

    return this.props.children;
  }
}

function ErrorBoundary({ errorFallback, errorComponent, children }) {
  return (
    <Boundary
      fallback={errorFallback || 'Something went wrong'}
      fallbackComponent={errorComponent}
    >
      {children}
    </Boundary>
  );
}

export default ErrorBoundary;
